import React, { Component } from 'react';
import TweenMax from "gsap/TweenMax";
import './css/resume.css';
import Article from './Article';
import PhysicsStory from './PhysicsStory';

class Resume extends Component {

  componentDidMount(){
    TweenMax.from(".skills-exp-bar", 1, {width: 0});
  }

  render() {
    const skills = {'Java': 4, 'C#': 3, 'Ruby' : 2, 'Python' : 2, 'PHP' : 3, 'HTML': 4, 'CSS' : 4, 'Javascript' : 3, 'SQL' : 2};
    let skillList = [];
    for (const [key, value] of Object.entries(skills)) {
      skillList.push(
        <li key={key}>
          <div className="skills-exp-bar" style={{width: value * 100}}>{key}</div>
        </li>
      );
    }

    return (
    <Article asideArticle = {<PhysicsStory onAsideSection={this.props.onAsideSection}/>} >
        <div id="article-main" className="flex-overflow-item">
          <h2>Resume</h2>
          <h3>Summary</h3>

          <div className="section-block">
            <div className="subsection">
              Recent graduate with 2 years of professional experience in full-stack web development using Agile methodologies. Positive and self-motivated. Combining strong problem solving background and quick, flexible thinking with industry experience to drive robust solutions in an ever-evolving technical landscape.
            </div>
          </div>

          <h3> Skills </h3>
          <div id="skills-block" className="section-block">
            <div className="subsection">
              <div className="subsection-title"> Languages </div>
              <div>
                <ul id="tech-skills-list">
                  {skillList}
                </ul>
              </div>
            </div>
            <div className="subsection">
              <div className="subsection-title"> Frameworks </div>
              <div> React, JQuery, GSAP, Play Framework,  ElasticSearch, Ruby on Rails </div>
            </div>
            <div className="subsection">
              <div className="subsection-title"> Development Tools </div>
              <div> Git, SVN, Unity,  Visual Studio, Photoshop</div>
            </div>
            <div className="subsection">
              <div className="subsection-title"> Other Skills </div>
              <div> Team Management, Public Speaking, Proposal Writing </div>
            </div>
          </div>
          
          <h3> Education </h3>
            
          <div className="section-block">
            <div className="subsection">
              <div className="subsection-title">Bachelor of Science in Physics <span className="subsection-date"> Class of 2018 </span></div>
              <div className="subsection-title">University of Washington <span className="subsection-date"> Seattle </span></div>
              <div> Computer Science Focus </div>
            </div>
            <div className="subsection">
              <div className="subsection-title">Awards and Accolades </div>
              <div> ASUW Senator, Dean's Listed, Honor Society Member </div>
            </div>
            <div className="subsection">
              <a href="/physicsstory" onClick={this.props.onAsideSection.bind(this, true)}>Why Physics? <i class="fas fa-long-arrow-alt-right"></i></a>
            </div>
          </div>
          
          <h3> Professional Experience </h3>

          <div className="section-block">
            <div className="subsection">
              <div className="subsection-title">Full-Stack Software Developer Intern <span className="subsection-date"> 2013 &ndash; 2015</span> </div>
              <div>Edifecs, Inc., Bellevue, Washington</div>
            </div>

            <ul>
              <li> Developed automated, asynchronous web application that streamlined publishing and retrieval of all technical documentation leading to higher organizational efficiency and higher customer satisfaction</li>
              <li> Developed MVC object-oriented application using Java and the frameworks Java Play Framework and Elastic Search (NoSQL) for backend </li> 
              <li> Proactively learned, evaluated, and deployed frameworks and technologies </li>
              <li> Developed robust, automated tools that integrated with existing pipelines and publishing formats for faster and more efficient publishing deliveries reducing turnaround time by 10-30%</li>
              <li> Designed lazy loading architecture to load application in less than 0.5 sec </li>
              <li> Developed features such as chapter browsing, breadcrumbs, simple and faceted search, asynchronous feedback forms, and user metrics </li>
              <li> Application became an indispensable tool for training new hires and solving customer inquiries </li>
              <li> Ensured cross-platform compatibility of all major web browsers </li>
              <li> Proactively communicated across multiple departments with key personnel to ensure quality, functionality, cohesion, and timely delivery </li>
              <li> Presented demonstrations to stakeholders to communicate value and generate interest </li>
            </ul>
          </div>

          <h3> Projects </h3>

          <div className="section-block">

            <div className="subsection">
              <div className="subsection-title"> Minesweeper ;) <span className="subsection-date">2018</span> </div>
              <div> A small game built with React. </div>
            </div>

            <div className="subsection">
              <div className="subsection-title"> Wei Kong Web <span className="subsection-date">2018</span> </div>
              <div> Dynamic front-end application built with React and GSAP </div>
            </div>

            <div className="subsection">
              <div className="subsection-title"> Ruby on Rails Movie Review DB <span className="subsection-date">2018</span> </div>
              <div> Movie review CRUD app that allowed users to post reviews and retrieve info. </div>
            </div>

            <div className="subsection"> 
              <div className="subsection-title"> 16Bit Dragons <span className="subsection-date">2016 &ndash; 2018</span> </div>
              <div> Side&ndash;scrolling infinite runner &#8220;shmup&#8221; game in Unity and C#. </div>
            </div>

            <div className="subsection">
              <div className="subsection-title"> Pallet Town <span className="subsection-date">2016</span> </div>
              <div> Recreated Pallet Town from Pok&#233;mon games using Unity and C# </div>
            </div>

            <div className="subsection">
              <div className="subsection-title"> Sample Search Engine <span className="subsection-date">2014</span> </div>
              <div> Developed search engine frontend to backend in C# with Azure and AWS. Features included incremental search, website crawling and indexing, and SQL queries.</div>
            </div>

            <div className="subsection">
              <div className="subsection-title"> Global Timelines <span className="subsection-date">2014</span> </div>
              <div> Designed and developed a website displaying timelines of different regions of the world by fetching data from APIs using Python, Javascript, HTML, and CSS. </div>
            </div>

            <div className="subsection">
              <div className="subsection-title"> Fluffy Muffin <span className="subsection-date">2011 &ndash; 2013</span> </div>
              <div> Developed webzine in PHP, Javascript, HTML, and CSS </div>
            </div>
          </div>
        </div>
      </Article>
    );
  }
}

export default Resume;


// WEBPACK FOOTER //
// ./src/Resume.js